import CheckBoxWithDescription from './CheckBoxWithDescription';

export default CheckBoxWithDescription;
